import { useRltPricingShowQuery } from "@/services/backend/rlt/pricing/api/service";
import { useResetFieldOnChange } from "@/shared/lib/errors/err-validation-failed-context";

/**
 * useResetFinalPriceOnChange resets the error of the final price whenever the
 * final price of the pricing changes. The final price is derived from the
 * base price, the discounts and the treatment, which may change on another
 * tab. Call it within the document's ErrValidationFailedContextProvider, in
 * a component mounted on every tab.
 */
export function useResetFinalPriceOnChange(pricingId: string) {
  const { data } = useRltPricingShowQuery({ id: pricingId });
  useResetFieldOnChange(
    "treatmentPrice.finalPrice",
    data?.treatmentPrice.finalPrice,
  );
}
